import Menu from '../../components/globalComponents/headerMenu/menu';
import SocialIcons from '../../components/globalComponents/socialIcons/socialIcons';
import GradientLine from '../../components/globalComponents/gradientLine/gradientLine';
import Footer from '../../components/globalComponents/footer/footer';

import './i+d+ipage.scss';
import HeaderIDI from '../../components/i+d+iComponents/headerI+D+I/headerI+D+I';
import PilaresTecnologicos from '../../components/i+d+iComponents/pilaresTecnológicos/pilaresTecnologicos';
import EstrategiasIDI from '../../components/i+d+iComponents/estrategiasIDI/estrategiasIDI';
import ContactUs from '../../components/companyInfoComponents/contactUs/contactUs';

const InvestigaciónDesarrolloInnovación = () => {
  return (
    <div>
      <Menu />
      <HeaderIDI />
      <PilaresTecnologicos />
      <EstrategiasIDI />
      <ContactUs />
      <SocialIcons />
      <GradientLine />
      <Footer />
    </div>
  );
};

export default InvestigaciónDesarrolloInnovación;
